<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <task-area-create-or-update v-model="taskArea"></task-area-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        name="task-area"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TaskAreaCreateOrUpdate from './components/TaskAreaCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        TaskAreaCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Görev Yeri",key:"Name", thClass:"w-100",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            loading:false,
            taskArea:{
                Id:null,
                Name:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.taskArea.Id = null
            this.taskArea.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.TaskArea.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.taskArea.Id = item.Id
            this.taskArea.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.TaskArea.CreateOrUpdate(this.editing,this.taskArea).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} görev yerini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.TaskArea.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>